<template>
  <div class="register absolute">
    <div class="shading">
      <div class="pictrue acea-row row-center-wrapper">
        <img :src="logoUrl" v-if="logoUrl" />
        <img src="@assets/images/logo2.png" v-else />
      </div>
    </div>
    <div class="whiteBg" v-if="formItem === 1">
     
      <div class="list">
        <form @submit.prevent="submit">
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-phone_"></use>
              </svg>
              <input
                type="text"
                placeholder="输入账号"
                v-model="account"
                required
              />
            </div>
          </div>
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-code_"></use>
              </svg>
              <input
                type="password"
                placeholder="输入密码"
                v-model="password"
                required
              />
            </div>
          </div>
        </form>
        <!--<div
          class="forgetPwd"
          @click="$router.push({ name: 'RetrievePassword' })"
        >
          <span class="iconfont icon-wenti"></span>忘记密码
        </div>-->
      </div>
     
 
      <div class="logon" @click="submit">登录</div>
      <div class="tip">
        没有账号?
        <span @click="formItem = 2" class="font-color-red">立即注册</span>
      </div>
    </div>
    <div class="whiteBg" v-else>
      <div class="title">注册账号</div>
      <div class="list">
        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-phone_"></use>
            </svg>
            <input type="text" placeholder="输入手机号码" v-model="account" />
          </div>
        </div>
       
        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_"></use>
            </svg>
            <input
              type="password"
              placeholder="填写您的登录密码"
              v-model="password"
            />
          </div>
        </div>
		<div class="item">
		  <div>
		    <svg class="icon" aria-hidden="true">
		      <use xlink:href="#icon-yonghu"></use>
		    </svg>
		    <input type="text" placeholder="输入姓名" v-model="real_name" />
		  </div>
		</div>
		<div class="item">
		  <div>
		    <svg class="icon" aria-hidden="true">
		      <use xlink:href="#icon-ditu"></use>
		    </svg>
		    <div class="address">
		      <div slot="right" @click.stop="show2 = true">
		        {{ model2 || "请选择地址" }}
		      </div>
		      <CitySelect
		        v-model="show2"
		        :callback="result2"
		        :items="district"
		        provance=""
		        city=""
		        area=""
		      ></CitySelect>
		    </div>
		  </div>
		</div>
		<div class="item">
		  <div>
		    <svg class="icon" aria-hidden="true">
		      <use xlink:href="#icon-dizhi"></use>
		    </svg>
		    <input type="text" placeholder="输入具体地址" v-model="address_juti" />
		  </div>
		</div>
		<!--<div class="item">
		  <div>
		    <svg class="icon" aria-hidden="true">
		      <use xlink:href="#icon-kefu_o"></use>
		    </svg>
		    <input type="text" placeholder="输入服务老师" v-model="laoshi" />
		  </div>
		</div>-->
      </div>
      <div class="logon" @click="register">注册</div>
      <div class="tip">
        已有账号?
        <span @click="formItem = 1" class="font-color-red">立即登录</span>
      </div>
    </div>
    <div class="bottom"></div>
  </div>
</template>
<script>
import sendVerifyCode from "@mixins/SendVerifyCode";
import { login, loginMobile, registerVerify, register,getAddress, postAddress  } from "@api/user";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { getLogo } from "@api/public";
import dayjs from "dayjs";
import cookie from "@utils/store/cookie";
import { CitySelect } from "vue-ydui/dist/lib.rem/cityselect";
import District from "ydui-district/dist/jd_province_city_area_id";
 
 

const BACK_URL = "login_back_url";

export default {
components: {
	  CitySelect
	},
  name: "Login",
  mixins: [sendVerifyCode],
  data: function() {
    return {
      navList: ["账号登录", "快速登录"],
	  show2: false,
	  model2: "",
	  district: District,
	  userAddress: { is_default: 0 },
	  address: {},
      current: 1,
      account: "",
      password: "",
      captcha: "",
      formItem: 1,
      type: "login",
      logoUrl: ""
    };
  },
  mounted: function() {
    this.getLogoImage();
  },
  methods: {
    async getLogoImage() {
      let that = this;
      getLogo(2).then(res => {
        that.logoUrl = res.data.logo_url;
      });
    },
    async loginMobile() {
      var that = this;
      const { account, captcha } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ]
          })
          .validate({ account, captcha });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      loginMobile({
        phone: that.account,
       
        spread: cookie.get("spread")
      })
        .then(res => {
          let data = res.data;
          let newTime = Math.round(new Date() / 1000);
          that.$store.commit(
            "LOGIN",
            data.token,
            dayjs(data.expires_time) - newTime
          );
          const backUrl = cookie.get(BACK_URL) || "/";
          cookie.remove(BACK_URL);
          that.$router.replace({ path: backUrl });
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    async register() {
      var that = this;
	  
      const { account, password, real_name,address_juti,laoshi } = that;
     /* try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ],
            password: [
              required(required.message("密码")),
              attrs.range([6, 16], attrs.range.message("密码")),
              alpha_num(alpha_num.message("密码"))
            ]
          })
          .validate({ account, captcha, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }*/
	  console.log(that);
	  console.log('2222');
      register({
        account: that.account,
       password: that.password,
        real_name: that.real_name,
		address: that.address,
		address_juti: that.address_juti,
		laoshi: that.laoshi,
        spread: cookie.get("spread")
      })
        .then(res => {
          that.$dialog.success(res.msg);
          that.formItem = 1;
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    async code() {
      var that = this;
      const { account } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({ account });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      if (that.formItem == 2) that.type = "register";
      await registerVerify({ phone: that.account, type: that.type })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    navTap: function(index) {
      this.current = index;
    },
    async submit() {
      const { account, password } = this;
      try {
        await this.$validator({
          account: [
            required(required.message("账号")),
            attrs.range([5, 16], attrs.range.message("账号")),
            alpha_num(alpha_num.message("账号"))
          ],
          password: [
            required(required.message("密码")),
            attrs.range([6, 16], attrs.range.message("密码")),
            alpha_num(alpha_num.message("密码"))
          ]
        }).validate({ account, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      login({ account, password })
        .then(({ data }) => {
          this.$store.commit("LOGIN", data.token, dayjs(data.expires_time));
          const backUrl = cookie.get(BACK_URL) || "/";
          cookie.remove(BACK_URL);
          //this.$router.replace({ path: backUrl });
		  this.$router.replace({ path: "/user" });
        })
        .catch(e => {
          this.$dialog.error(e.msg);
        });
    },
	getUserAddress: function() {
	  if (!this.id) return false;
	  let that = this;
	  getAddress(that.id).then(res => {
	    that.userAddress = res.data;
	    that.model2 =
	      res.data.province + " " + res.data.city + " " + res.data.district;
	    that.address.province = res.data.province;
	    that.address.city = res.data.city;
	    that.address.district = res.data.district;
	  });
	},
	getAddress() {
	  openAddress().then(userInfo => {
	    this.$dialog.loading.open();
	    postAddress({
	      id: this.id,
	      real_name: userInfo.userName,
	      phone: userInfo.telNumber,
	      address: {
	        province: userInfo.provinceName,
	        city: userInfo.cityName,
	        district: userInfo.countryName
	      },
	      detail: userInfo.detailInfo,
	      is_default: 1,
	      post_code: userInfo.postalCode
	    })
	      .then(() => {
	        this.$dialog.loading.close();
	        this.$dialog.toast({ mes: "添加成功" });
	        this.$router.go(-1);
	      })
	      .catch(err => {
	        this.$dialog.loading.close();
	        this.$dialog.error(err.msg || "添加失败");
	      });
	  });
	},
	result2(ret) {
	  this.model2 = ret.itemName1 + " " + ret.itemName2 + " " + ret.itemName3;
	  this.address.province = ret.itemName1;
	  this.address.city = ret.itemName2;
	  this.address.district = ret.itemName3;
	}
  }
};
</script>
